// extracted by mini-css-extract-plugin
module.exports = {"container":"LocalPay_container__37qdE"};